import { toursTrackType } from '@/masterdata/tours_tracktype'
import type { Tour, TourListItem, Track } from '@/types/tour'

const SAILING_TRACK_TYPE_ID = 'sailing'

const trackTypeEntries = Object.values(toursTrackType).flatMap((category) =>
  Object.values(category),
)

const knownTrackTypeIds = new Set(trackTypeEntries.map((entry) => entry.garmin_id))

const trackTypeNameLookup = Object.fromEntries(
  trackTypeEntries.map((entry) => [entry.garmin_id, entry.name]),
)

const trackTypeCategoryLookup = Object.fromEntries(
  trackTypeEntries.map((entry) => [entry.garmin_id, entry.category]),
)

export function isKnownTrackTypeId(value: string | null | undefined): value is string {
  return typeof value === 'string' && knownTrackTypeIds.has(value)
}

export function getTrackTypeName(value: string | null | undefined): string | undefined {
  if (!value) return undefined
  return trackTypeNameLookup[value]
}

export function getTrackTypeCategory(value: string | null | undefined): string | undefined {
  if (!value) return undefined
  return trackTypeCategoryLookup[value]
}

export function isSailingTrackType(value: string | null | undefined): boolean {
  return value === SAILING_TRACK_TYPE_ID
}

export function shouldHideAscentForTrack(
  track: Pick<Track, 'type'> | null | undefined,
  tourType?: string | null,
): boolean {
  return isSailingTrackType(tourType) || isSailingTrackType(track?.type)
}

export function shouldHideAscentForTour(
  tour: Pick<Tour, 'type' | 'tracks'> | null | undefined,
  tracks: Array<Pick<Track, 'type'>> | undefined = tour?.tracks ?? [],
  tourTypeOverride?: string | null,
): boolean {
  const tourType = tourTypeOverride === undefined ? tour?.type : tourTypeOverride
  if (isSailingTrackType(tourType)) return true
  if (!tracks || tracks.length === 0) return false
  return tracks.every((track) => isSailingTrackType(track.type))
}

export function shouldHideAscentForTourListItem(
  tour: Pick<TourListItem, 'type' | 'trackTypes'> | null | undefined,
): boolean {
  if (isSailingTrackType(tour?.type)) return true
  const trackTypes = tour?.trackTypes ?? []
  return trackTypes.length > 0 && trackTypes.every(isSailingTrackType)
}
